var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _circle4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse, _ellipse2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 482,
    viewBox: "0 0 610 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M583.079 92.2136C562.107 69.8294 545.872 43.1067 520.805 24.8392C481.431 -3.91515 424.764 -6.71872 378.724 11.3448C332.685 29.4083 296.82 65.8192 273.181 107.048C260.746 128.74 250.979 152.402 232.758 170.128C217.355 185.104 197.11 194.659 177.915 205.066C146.967 221.799 117.163 242.018 97.1357 269.761C77.1086 297.504 68.1542 333.942 80.9571 365.207C89.5901 386.304 106.979 403.09 124.793 418.288C145.757 436.157 168.289 452.889 194.292 463.536C226.848 476.782 262.987 479.63 298.427 480.978C361.255 483.358 424.184 481.579 486.746 475.655C537.976 470.811 590.757 462.542 633.62 435.775C693.663 398.291 724.621 329.612 731.59 262.264C734.426 235.329 733.708 207.337 722.626 182.345C696.122 122.565 624.609 136.547 583.079 92.2136Z",
    fill: "#EFF1F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.317 202.334C178.317 202.334 161.717 199.387 157.067 211.003C152.417 222.619 157.067 262.736 157.067 262.736L219 307L178.317 202.334Z",
    fill: "#3F3D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.202 379.727L231.647 386.735C228.079 387.744 224.337 385.783 223.275 382.349C222.228 378.911 224.262 375.303 227.825 374.28L252.347 367.266C255.912 366.256 259.654 368.213 260.719 371.645C261.777 375.078 259.758 378.69 256.202 379.727Z",
    fill: "#2BD0D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 395,
    r: 11,
    fill: "#25233A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 397.5,
    r: 5.5,
    fill: "#3F3D56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 384,
    r: 11,
    fill: "#25233A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214 384.5C214 387.538 211.538 390 208.5 390C205.462 390 203 387.538 203 384.5C203 381.462 205.462 379 208.5 379C211.538 379 214 381.462 214 384.5Z",
    fill: "url(#paint0_linear_0_539)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 399,
    r: 11,
    fill: "#25233A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216 399.5C216 402.538 213.538 405 210.5 405C207.462 405 205 402.538 205 399.5C205 396.462 207.462 394 210.5 394C213.538 394 216 396.462 216 399.5Z",
    fill: "#3F3D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.085 390.874L206.298 380.828C202.724 380.111 200.414 376.698 201.13 373.192C201.862 369.692 205.341 367.428 208.915 368.126L259.702 378.153C263.276 378.87 265.586 382.284 264.87 385.79C264.147 389.297 260.666 391.571 257.085 390.874Z",
    fill: "#2BD0D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226 310H240V368.999C240 372.866 236.867 376 233.003 376C229.139 376 226.007 372.866 226.007 368.999V310H226Z",
    fill: "#2BD0D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.187 386.708L206.65 393.733C203.082 394.747 199.336 392.784 198.275 389.345C197.228 385.904 199.262 382.295 202.823 381.271L227.36 374.266C230.924 373.255 234.664 375.214 235.728 378.647C236.767 382.082 234.739 385.681 231.187 386.708Z",
    fill: "#2BD0D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236 386.26L232.875 386.811C231.943 386.974 230.968 387.033 230 386.983L231.305 386.755C232.212 386.598 233.063 386.342 233.812 386L236 386.26Z",
    fill: "url(#paint1_linear_0_539)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M261 372.738C260.999 374.293 260.483 375.799 259.54 377L239 372.65C239.517 371.913 239.89 371.077 240.098 370.188L252.752 366.265C254.398 365.768 256.165 365.976 257.665 366.844C259.165 367.711 260.274 369.168 260.748 370.892C260.912 371.492 260.997 372.114 261 372.738Z",
    fill: "url(#paint2_linear_0_539)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M225.221 371.103C225.074 370.585 225 370.055 225 369.523V311H230.943V374.071C230.884 374.38 230.904 374.697 231 375C230.1 374.685 229.135 374.511 228.155 374.489C227.464 374.449 226.77 374.449 226.079 374.489L226.504 374.389C226.766 374.349 225.564 372.298 225.221 371.103Z",
    fill: "url(#paint3_linear_0_539)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M262.289 389.8C261.319 390.323 260.228 390.597 259.119 390.596C258.673 390.595 258.228 390.552 257.79 390.467L235.382 386.06L233.515 385.697C232.878 386.175 232.154 386.533 231.382 386.752L230.272 387.069L207.247 393.735C203.733 394.742 200.045 392.792 199 389.373C200.997 391.178 204.029 391.346 206.223 389.774C209.034 387.878 220.225 385.031 226.564 383.517C229.56 382.819 231.852 380.468 232.412 377.518C232.428 377.344 232.454 377.171 232.492 377C233.548 378.113 235.489 379.362 238.997 380.423C247.636 383.012 261.664 384.727 261.664 384.727C261.664 384.727 264.196 387.147 262.289 389.8Z",
    fill: "url(#paint4_linear_0_539)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264 388C263.472 388.778 262.793 389.456 262 390C262.538 389.479 263.229 388.785 264 388Z",
    fill: "url(#paint5_linear_0_539)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.299 370.559C226.577 371.729 227.163 372.809 228 373.688C227.791 373.728 227.575 373.781 227.359 373.84L206.088 380C202.817 379.187 200.662 376.135 201.044 372.854C201.425 369.574 204.225 367.073 207.6 367C208.053 367.001 208.505 367.045 208.949 367.132L226.299 370.559Z",
    fill: "url(#paint6_linear_0_539)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259 89.4074C259 89.4074 258.724 68.6021 241.925 70.3961C225.126 72.1901 226.414 65.3019 219.238 66.0583C212.063 66.8147 203.727 73.8436 206.121 82.5258C208.516 91.2081 199.789 93.1494 194.057 99.7364C188.324 106.323 195.406 111.712 205.063 118.152C214.72 124.592 204.463 122.925 210.188 133.107C215.914 143.288 235.295 130.282 235.295 130.282L259 89.4074Z",
    fill: "#503164"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.664 434.601L134.393 435V341.255C134.393 341.255 134.984 317.014 157.846 314.582C180.707 312.151 388.042 282.116 388.042 282.116C388.042 282.116 396.26 281.246 400.993 297.017C405.726 312.788 410.333 374.804 410.333 374.804L473.973 383.381C473.973 383.381 475.652 273.832 452.671 267.786C429.69 261.741 129.149 292.546 129.149 292.546C129.149 292.546 106.858 408.898 122.664 434.601Z",
    fill: "#2BD0D0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.197289,
    d: "M122.664 434.601L134.393 435V341.255C134.393 341.255 134.984 317.014 157.846 314.582C180.707 312.151 388.042 282.116 388.042 282.116C388.042 282.116 396.26 281.246 400.993 297.017C405.726 312.788 410.333 374.804 410.333 374.804L473.973 383.381C473.973 383.381 475.652 273.832 452.671 267.786C429.69 261.741 129.149 292.546 129.149 292.546C129.149 292.546 106.858 408.898 122.664 434.601Z",
    fill: "url(#paint7_linear_0_539)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62 303.784C62 303.784 67.744 272.028 108.144 263.705L393.327 231.062C393.327 231.062 421.323 229.902 434.131 237.649C446.939 245.395 465.219 251.817 472.714 286.872C480.209 321.928 482 381.814 482 381.814L474.91 382.914C474.91 382.914 464.562 274.474 453.599 267.608C442.635 260.743 146.196 302.863 146.196 302.863C146.196 302.863 125.635 306.951 123.844 337.395C122.053 367.838 123.844 434 123.844 434L62 409.057V303.784Z",
    fill: "#2BD0D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M355.425 243.844C340.663 241.944 325.781 240.568 310.906 241.125C299.727 241.557 288.62 243.09 277.534 244.617L179.759 258.12C178.1 258.349 176.209 258.723 175.38 260.164C173.787 262.916 177.529 265.628 180.561 266.676C213.071 277.932 247.804 289.332 281.269 281.306C296.569 277.637 310.78 270.018 326.299 267.371C341.817 264.724 357.747 267.161 373.232 264.665C387.789 262.32 401.649 255.656 416.404 255.591C420.929 255.591 425.587 256.168 429.879 254.752C434.172 253.337 437.967 249.013 436.779 244.702C422.926 244.224 407.375 241.695 393.787 244.44C380.338 247.152 368.893 243.844 355.425 243.844Z",
    fill: "url(#paint8_linear_0_539)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267 259.38L267.57 261.494C267.57 261.494 284.451 271.667 284.345 271.995C284.239 272.323 354.369 255.756 354.369 255.756L356 251L267 259.38Z",
    fill: "#2BD0D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267 259.38L267.57 261.494C267.57 261.494 284.451 271.667 284.345 271.995C284.239 272.323 354.369 255.756 354.369 255.756L356 251L267 259.38Z",
    fill: "url(#paint9_linear_0_539)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M268 259.364L330.107 246L356 251.054L285.442 268L268 259.364Z",
    fill: "#2BD0D0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M268 259.364L330.107 246L356 251.054L285.442 268L268 259.364Z",
    fill: "url(#paint10_linear_0_539)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M247.832 270.484L262.289 270.996C262.289 270.996 265.961 271.224 266.91 268.279C267.859 265.334 261.02 259.119 260.287 259.002C259.554 258.884 240.528 264.221 243.27 269.558L247.832 270.484Z",
    fill: "#2BD0D0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M247.832 270.484L262.289 270.996C262.289 270.996 265.961 271.224 266.91 268.279C267.859 265.334 261.02 259.119 260.287 259.002C259.554 258.884 240.528 264.221 243.27 269.558L247.832 270.484Z",
    fill: "url(#paint11_linear_0_539)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79 416.056L71.9416 437.733C51.4688 445.084 34.0624 437.733 34.0624 437.733L29 415C29 415 54.5351 423.56 79 416.056Z",
    fill: "#2BD0D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79 416.056L71.9416 437.733C51.4688 445.084 34.0624 437.733 34.0624 437.733L29 415C29 415 54.5351 423.56 79 416.056Z",
    fill: "url(#paint12_linear_0_539)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87 396L84.7159 412.943L78.9296 415.951C54.2815 423.372 28.5146 414.913 28.5146 414.913L24.0722 411.63L22 396H87Z",
    fill: "#2BD0D0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87 396L84.7159 412.943L78.9296 415.951C54.2815 423.372 28.5146 414.913 28.5146 414.913L24.0722 411.63L22 396H87Z",
    fill: "url(#paint13_linear_0_539)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5,
    cy: 395,
    rx: 32.5,
    ry: 6,
    fill: "#2BD0D0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5,
    cy: 395,
    rx: 32.5,
    ry: 6,
    fill: "url(#paint14_linear_0_539)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6413 265.03C36.4587 263.515 33.0383 262.372 30.2849 260.159C24.7383 255.661 23.3319 247.912 21.5953 240.962C19.8587 234.011 16.4978 226.369 9.65051 224.375C7.08854 223.638 4.08418 223.93 2.1363 225.764C0.0827689 227.698 -0.33322 230.874 0.228035 233.679C0.789289 236.483 2.15611 238.995 3.21259 241.653C5.67965 247.826 6.43061 254.559 5.38497 261.13C4.51998 266.519 2.45324 271.981 3.78045 277.264C6.03207 286.228 17.2506 291.485 17.5609 300.721C17.7722 306.954 12.6747 312.722 13.8302 318.856C14.682 323.394 18.8353 326.936 19.0598 331.548C19.3107 336.778 14.3981 341.203 14.6358 346.433C14.8735 351.663 20.0634 355.158 23.4508 359.272C26.2905 362.726 27.979 366.992 28.2776 371.465C28.4558 374.256 28.0993 377.147 29.0039 379.792C29.6642 381.725 30.9848 383.367 32.0082 385.108C33.1374 386.988 33.9891 389.022 35.3494 390.763C38.8482 395.201 44.6824 397.044 50.074 395.414C51.1239 388.464 50.2061 381.373 50.4966 374.349C51.0711 360.74 56.1884 347.025 52.9133 333.814C51.7116 328.97 49.4005 324.371 48.9911 319.401C48.628 314.962 49.8033 310.563 50.6221 306.184C52.3124 297.14 52.286 287.79 51.5927 278.646C51.0447 271.39 45.9736 268.047 39.6413 265.03Z",
    fill: "#2BD0D0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7518 300.767C59.6986 306.829 61.0819 313.096 59.14 318.852C57.6703 323.214 54.4382 326.786 52.769 331.075C48.9184 340.974 54.099 352.075 53.0416 362.644C52.6027 366.999 51.1064 371.182 50.162 375.458C48.9892 380.871 48.7017 386.438 49.3108 391.943C49.1819 394.015 50.5994 395.865 52.636 396.285C55.8944 397.526 59.2699 398.435 62.7112 399C61.5478 392.591 62.7731 385.979 66.1561 380.41C71.4298 371.78 81.6779 365.964 83.5866 356.051C84.8767 349.339 81.8708 342.527 82.0836 335.696C82.2368 331.15 83.8034 326.765 86.5659 323.148C89.0465 319.921 92.4049 317.425 94.7126 314.079C100.259 306.012 98.5298 295.23 96.8806 285.584C95.2313 275.937 94.2736 264.836 100.791 257.527C102.853 255.216 105.539 253.483 107.408 251.014C111.571 245.51 110.52 237.031 105.679 232.112C100.838 227.192 93.0433 225.831 86.4595 227.996C83.6823 228.813 81.2311 230.477 79.4501 232.756C76.1249 237.47 77.455 243.91 78.8648 249.513C80.0951 254.38 81.086 259.996 79.4035 264.903C78.1466 268.554 74.9611 270.533 72.2544 273.075C64.5031 280.235 59.9917 290.227 59.7518 300.767Z",
    fill: "#2BD0D0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0622 354.522C52.1243 361.115 50.7703 367.761 50.4929 374.373V375.038C50.478 375.202 50.4402 375.363 50.3806 375.517C49.209 380.934 48.9168 386.507 49.5153 392.018C49.5508 392.911 49.776 393.786 50.1758 394.584C50.1428 394.863 50.1031 395.135 50.0635 395.414C44.6702 397.044 38.8341 395.201 35.3342 390.762C34.0131 389.021 33.1215 386.987 31.992 385.107C30.9352 383.359 29.6472 381.717 28.9867 379.79C28.0818 377.132 28.4384 374.254 28.2601 371.463C27.9615 366.989 26.2724 362.722 23.4318 359.267C20.0434 355.18 14.8452 351.751 14.614 346.434C14.3828 341.117 19.2904 336.778 19.0394 331.547C18.8148 326.935 14.6602 323.393 13.8082 318.854C12.6523 312.719 17.7712 306.951 17.5401 300.717C17.2296 291.479 6.00756 286.222 3.75523 277.257C2.43421 271.973 4.495 266.51 5.36026 261.121C6.41093 254.558 5.66893 247.832 3.21361 241.661C2.15679 239.003 0.78954 236.498 0.228107 233.686C-0.333326 230.875 0.0827951 227.705 2.13698 225.764C4.11851 223.93 7.0908 223.638 9.65357 224.375C16.5097 226.369 19.8584 234.039 21.6022 240.99C23.3459 247.942 24.7462 255.684 30.2945 260.19C33.0356 262.417 36.4702 263.546 39.6539 265.062C45.9948 268.079 51.0675 271.422 51.6091 278.613C52.2696 287.757 52.3291 297.108 50.6382 306.153C49.8191 310.533 48.6566 314.932 49.0067 319.372C49.3568 323.811 51.2789 328.012 52.5338 332.318C52.6725 332.803 52.8112 333.295 52.9301 333.787C54.5946 340.626 54.0596 347.544 53.0622 354.522Z",
    fill: "#30C59B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7185 394C49.421 393.229 49.2496 392.38 49.2157 391.512C48.7851 386.152 49.0001 380.733 49.8525 375.465C49.8765 375.31 49.9052 375.155 49.9339 375C49.7616 381.346 50.3074 387.744 49.7185 394Z",
    fill: "url(#paint15_linear_0_539)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.393 251.014C105.522 253.483 102.831 255.216 100.766 257.527C94.2387 264.83 95.1978 275.937 96.8496 285.584C98.5014 295.23 100.233 306.012 94.6783 314.079C92.3671 317.398 89.0035 319.921 86.5191 323.148C83.7523 326.765 82.1834 331.15 82.0299 335.696C81.8168 342.527 84.8274 349.339 83.5352 356.051C81.6236 365.964 71.3598 371.793 66.078 380.41C62.7025 385.984 61.4851 392.595 62.6545 399C59.2166 398.435 55.8447 397.526 52.5904 396.285C51.7003 396.021 50.893 395.534 50.2459 394.87C50.1541 394.763 50.0717 394.647 49.9995 394.525C49.5866 393.735 49.3482 392.866 49.3001 391.976C48.701 386.469 49.0002 380.902 50.186 375.491C50.2193 375.331 50.2592 375.172 50.2992 375.013C51.245 370.903 52.6437 366.873 53.07 362.677C53.2966 359.957 53.243 357.221 52.9101 354.511C53.9159 347.54 54.4554 340.629 52.7569 333.843C52.637 333.352 52.4972 332.861 52.3573 332.376C52.4839 331.951 52.6304 331.526 52.7969 331.108C54.4687 326.819 57.7057 323.247 59.1777 318.885C61.1159 313.129 59.7372 306.862 59.7904 300.8C59.877 290.331 64.6127 280.219 72.219 273.075C74.9298 270.533 78.1202 268.554 79.3791 264.903C81.0642 259.996 80.0451 254.38 78.8395 249.513C77.4209 243.91 76.0754 237.47 79.4257 232.756C81.0908 230.419 83.715 228.899 86.4459 227.996C93.0131 225.831 100.853 227.192 105.695 232.112C110.537 237.031 111.563 245.543 107.393 251.014Z",
    fill: "#30C59B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M225.573 146.146C225.573 146.146 197.756 150.446 184.889 181.123C172.022 211.8 178.713 249.806 178.938 253.15C179.163 256.494 218.366 271 229.573 271C240.781 271 243.115 259.771 243.115 259.771L223.312 251.338L283.482 244.389H294.286L288.335 254.421C288.335 254.421 300.078 255.652 307.927 255.932C315.775 256.213 321.105 240.691 321.984 232.973C322.863 225.256 287.317 157.515 282.007 153.503C276.698 149.49 262.29 139.686 225.573 146.146Z",
    fill: "#2BD0D0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M258.392 88.7763C258.392 88.7763 263.424 91.6061 262.971 100.761C262.519 109.916 259.682 123.693 256.819 127.261C253.955 130.83 243.94 132.229 243.94 132.229C243.94 132.229 249.403 145.206 253.469 148.555C257.535 151.904 249.383 164.242 241.454 160.194C233.526 156.145 224.334 145.978 224.334 145.978C224.334 145.978 230.946 133.733 228.71 127.288C226.475 120.843 217.938 98.2245 224.334 92.0455C230.73 85.8666 244.52 77.011 258.392 88.7763Z",
    fill: "url(#paint16_linear_0_539)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M214.334 190L210 244.055L223.238 251L234 249.122L220.572 232.618L214.334 190Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M284 187C284 187 301.909 229.077 293.97 244L287.854 242.839L284 187Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M235.522 258.045C235.522 258.045 228.756 263.82 231.776 268.312C234.796 272.803 238.401 272.675 241.407 270.667C244.413 268.658 250.318 263.891 257.353 266.079C264.388 268.267 266.097 269.659 266.097 269.659C266.097 269.659 269.802 267.343 268.841 265.02C267.879 262.697 260.521 255.171 258.389 254.195C256.257 253.22 247.406 256.216 247.406 256.216C247.406 256.216 240.903 254.458 235.522 258.045Z",
    fill: "url(#paint17_linear_0_539)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M295.191 245.598C295.191 245.598 288.806 246.357 287.193 250.555C285.58 254.753 285 255.264 285 255.264C285 255.264 288.606 255.955 290.106 254.001C291.605 252.047 293.165 252.868 293.165 252.868L292.718 255.375C292.718 255.375 302.516 256.852 306.942 255.264C311.367 253.676 313.267 251.812 313.267 251.812L315 247.572C315 247.572 310.821 244.541 307.668 244.072C304.516 243.602 295.191 245.598 295.191 245.598Z",
    fill: "url(#paint18_linear_0_539)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M328.893 290C328.893 290 350.827 306.687 348.877 329.259C346.928 351.831 344.064 385.346 344.064 385.346C344.064 385.346 335.218 389.068 329.357 385.346C323.495 381.624 319.946 330.697 317.042 325.833C314.138 320.969 296.667 299.042 278 297.154L328.893 290Z",
    fill: "#25233A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M219 306.058C219 306.058 229.444 315.953 248.062 319.06C266.681 322.167 275.359 324.76 281.049 340.665C286.739 356.57 292.197 390.802 293.984 394.628C295.77 398.454 303.366 396.502 303.366 396.502C303.366 396.502 307.662 391.607 307.662 364.388C307.662 326.442 310.317 318.664 300.749 309.132C291.181 299.599 282.477 297 282.477 297L219 306.058Z",
    fill: "#3F3D56"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M294 396L295.82 410.197H299.228C299.228 410.197 321.176 411.384 321.864 410.872C322.552 410.359 320.807 399.629 312.492 399.932C304.176 400.236 303.631 397.909 303.631 397.909L294 396Z",
    fill: "#25233A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M331 386.156L334.518 400L372.955 394.788C372.955 394.788 374.308 385.695 362.132 386.597C358.918 386.831 356.524 389.062 352.661 389.082C348.798 389.102 345.098 387.539 343.15 385L331 386.156Z",
    fill: "#25233A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M461.804 212.337L319.561 219.991C316.121 220.172 313.185 217.52 313 214.065C313 213.958 313 213.845 313 213.739V112.473C313.003 108.372 316.267 105.025 320.348 104.938L462.009 102.001C463.827 101.964 465.584 102.654 466.895 103.918C468.206 105.183 468.964 106.92 469 108.745V204.716C468.995 208.772 465.836 212.118 461.804 212.337Z",
    fill: "#2BD0D0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M469.804 212.337L327.555 219.992C324.115 220.169 321.182 217.514 321 214.058C321 213.952 321 213.846 321 213.739V112.473C320.996 108.371 324.26 105.021 328.342 104.938L470.022 102.001C473.799 101.931 476.92 104.944 477 108.739V204.716C476.995 208.773 473.836 212.119 469.804 212.337Z",
    fill: "#2BD0D0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M469.804 212.337L327.555 219.992C324.115 220.169 321.182 217.514 321 214.058C321 213.952 321 213.846 321 213.739V112.473C320.996 108.371 324.26 105.021 328.342 104.938L470.022 102.001C473.799 101.931 476.92 104.944 477 108.739V204.716C476.995 208.773 473.836 212.119 469.804 212.337Z",
    fill: "url(#paint19_linear_0_539)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M427.773 251.138L391.478 255C391.478 255 380.425 252.77 381.023 251.138C381.622 249.505 393.179 247.933 393.179 247.933V182.129C393.08 181.983 391.558 180.045 387.39 178.81C386.583 178.571 385.762 178.38 384.931 178.24C384.217 178.135 383.523 177.925 382.871 177.616C380.392 176.335 383.13 174.105 386.978 174.006C387.581 173.985 388.184 174.02 388.78 174.112H416.693C416.693 174.112 427.261 177.085 427.773 191.923C428.284 206.762 427.773 251.138 427.773 251.138Z",
    fill: "#3A3054"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M398 251.277L391.322 255C391.322 255 380.434 252.77 381.023 251.137C381.612 249.505 393.018 247.932 393.018 247.932V182.123C392.88 181.971 391.211 180.225 387.315 178.805C385.865 178.288 384.376 177.888 382.863 177.61C380.421 176.329 383.118 174.1 386.909 174C390.137 174.445 396.494 178.028 396.907 180.073C397.319 182.117 398 251.277 398 251.277Z",
    fill: "#51466B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M263 389C262.119 390.001 261.709 390.371 262.23 389.547C262.5 389.388 262.757 389.205 263 389Z",
    fill: "url(#paint20_linear_0_539)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_539",
    x1: 203,
    y1: 390,
    x2: 214,
    y2: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_539",
    x1: 229.992,
    y1: 387.001,
    x2: 236,
    y2: 387.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_539",
    x1: 263.916,
    y1: 107.831,
    x2: 276.23,
    y2: 130.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_539",
    x1: 289.529,
    y1: -96.5601,
    x2: 244.041,
    y2: -96.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_539",
    x1: 357.142,
    y1: 99.9992,
    x2: 346.535,
    y2: 50.8935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_539",
    x1: 309.847,
    y1: 54.3179,
    x2: 305.879,
    y2: 53.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_539",
    x1: 258.106,
    y1: 99.5083,
    x2: 241.633,
    y2: 118.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_539",
    x1: 524.505,
    y1: 22.5488,
    x2: 33.0621,
    y2: -84.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_539",
    x1: 212.123,
    y1: 244.726,
    x2: 474.119,
    y2: 244.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_539",
    x1: 75.4557,
    y1: 225.212,
    x2: 76.9992,
    y2: 332.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_539",
    x1: 197.154,
    y1: 250.814,
    x2: 206.217,
    y2: 297.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_539",
    x1: 237.493,
    y1: 260.691,
    x2: 236.892,
    y2: 279.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_539",
    x1: 126.11,
    y1: 47.9536,
    x2: 82.3712,
    y2: 41.7094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_539",
    x1: 133.367,
    y1: 77.1729,
    x2: 98.5351,
    y2: 67.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_539",
    x1: -192.124,
    y1: 370.797,
    x2: -192.764,
    y2: 463.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_539",
    x1: 78.2068,
    y1: 64.7284,
    x2: 74.684,
    y2: 64.7885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_539",
    x1: 221.984,
    y1: 161.009,
    x2: 262.998,
    y2: 161.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_539",
    x1: 268.632,
    y1: 233.608,
    x2: 306.631,
    y2: 233.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_539",
    x1: 322.292,
    y1: 239.852,
    x2: 352.292,
    y2: 239.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_539",
    x1: 450.177,
    y1: 203.011,
    x2: 326.849,
    y2: 346.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362958",
    stopOpacity: 0.500601
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34313D",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_0_539",
    x1: 302.125,
    y1: 46.1652,
    x2: 300.959,
    y2: 45.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ba02b8b0829fd215f58b6658d97cd83.svg";
export { ForwardRef as ReactComponent };